import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getPlanningActualData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLANNING_ACTUAL.GET_FILTERED_DATA}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postAutoSaveData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLANNING_ACTUAL.AUTOSAVE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getYearsPlanningActualData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLANNING_ACTUAL.GET_YEAR_DATA}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
